import { Component } from 'solid-js';

const Home: Component = () => {
	return (
		<div class='flex flex-col items-center justify-center h-screen '>
			<h1 class='text-3xl font-bold underline'>Hello world!</h1>
			<i class='fas fa-cannabis color' />
		</div>
	);
};

export default Home;
